export const COPYRIGHT_LABEL = "by Crafttalk"
export const MOUNT_POINT = "root"
export const THEME_SETTINGS_FILE_DEFAULT = "themeSettings.json"
export const BOT_ID = "__SYSTEM__"
export const SIDEBARS_STATE = "sidebars-state"
export const DIALOG_TOPICS_COLLAPSED = "dialog-topics-collapsed"
